export const VIDEO_META: Record<string, { favicon: string; domain: string }> = {
  Youtube: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/youtube-icon.svg",
    domain: "youtube.com",
  },
  Vimeo: {
    favicon: "https://www.storydoc.com/assets/images/companies/vimeo-icon.svg",
    domain: "vimeo.com",
  },
  Loom: {
    favicon: "https://www.storydoc.com/assets/images/companies/loom-icon.svg",
    domain: "loom.com",
  },
  Vidyard: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/vidyard-icon.svg",
    domain: "vidyard.com",
  },
};
